module.exports = __webpack_public_path__ + "static/img/bannerBg.8e9075c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/publicService/cloudUp/bannerBg.png
// module id = uVir
// module chunks = 2